<app-fs-header></app-fs-header>
<header>
  <a [routerLink]="'/home'" routerLinkActive="active-link">
    <img
      class="ciao-logo-full"
      src="assets/img/ciao/ciao-logo-brown-full.svg"
      alt="ciao logo"
    />
    <img
      class="ciao-logo"
      src="assets/img/ciao/ciao-logo-brown.svg"
      alt="ciao logo"
    />
  </a>
  <ciao-dev-user-switcher
    *ngIf="showDevSwitcher"
    class="dev-switcher-header"
  ></ciao-dev-user-switcher>
  <ng-container *ngIf="currentUser$ | async as user; else notLoggedInNameplate">
    <span class="login-info" data-cy="user-info">
      <span
        *ngIf="usdaVerification$ | async as usda"
        class="usda-verification"
        [class.verified]="usda.verified"
        [attr.data-cy]="
          usda.verified ? 'usda-verified' : 'usda-verification-warning'
        "
      >
        <ng-container *ngIf="usda.verified; else usdaUnverified">
          <mat-icon>check_circle</mat-icon>
          <!-- Collapsed to the check alone until hover. Kept in the DOM rather
               than swapped in, so screen readers still get the label. Under the
               narrow-header breakpoint it becomes a hover/focus flyout instead
               of expanding inline. -->
          <span class="verification-flyout">Verified USDA account</span>
        </ng-container>

        <ng-template #usdaUnverified>
          <mat-icon>warning</mat-icon>
          <!-- Text + resend link: inline on wide headers, a hover/focus flyout
               under the narrow-header breakpoint. -->
          <span class="verification-flyout">
            <span class="verification-text">Unverified USDA account</span>
            <button
              class="btn-link"
              [disabled]="isResendingVerification"
              (click)="resendUsdaVerification(usda.user)"
              data-cy="resend-verification"
            >
              {{
                isResendingVerification
                  ? "Sending..."
                  : "Resend verification email"
              }}
            </button>
          </span>
        </ng-template>
      </span>

      <a
        [routerLink]="'/my-profile'"
        class="display-name semantic-button"
        data-cy="user-name"
      >
        {{ user.person.displayName }}
      </a>

      <button
        class="signout-button btn-action-solid"
        (click)="authService.logout()"
        data-cy="logout-button"
      >
        Sign Out
      </button>
    </span>
  </ng-container>
  <ng-template #notLoggedInNameplate>
    <span class="login-info">Not Logged In</span>
  </ng-template>
</header>

<nav class="navbar" data-cy="main-nav">
  <a
    class="ciao-logo-reversed"
    [routerLink]="'/home'"
    routerLinkActive="active-link"
  >
    <span class="screenreader">Home</span>
  </a>
  <a class="user-profile-mobile" [routerLink]="'/my-profile'">
    <span class="screenreader">My Profile</span>
  </a>
  <button class="signout semantic-button" (click)="authService.logout()">
    Sign Out
  </button>

  <button class="semantic-button menu-btn" #menubtn id="menu-btn">
    <span class="bar"> </span>
    <span class="bar"> </span>
    <span class="bar"> </span>
  </button>

  <div class="navbar-links">
    <a class="home" [routerLink]="'/home'" routerLinkActive="active-link">
      <span class="screenreader">Home</span>
    </a>

    <ng-template ngFor let-link [ngForOf]="activeRouterLinks$ | async">
      <a
        [routerLink]="link.url"
        routerLinkActive="active-link"
        [attr.data-cy]="link.title.toLowerCase() + '-nav'"
      >
        {{ link.title }}
      </a>
    </ng-template>
  </div>
</nav>

<div class="mobile-nav navbar-links" #links data-cy="mobile-menu">
  <span>
    <a
      class="home"
      (click)="removeActive()"
      [routerLink]="'/home'"
      routerLinkActive="active-link"
    >
      <span class="screenreader">Home</span>
    </a>
  </span>
  <ng-template ngFor let-link [ngForOf]="activeRouterLinks$ | async">
    <span>
      <a
        [routerLink]="link.url"
        (click)="removeActive()"
        class="link"
        routerLinkActive="active-link"
        [attr.data-cy]="link.title.toLowerCase() + '-nav'"
      >
        {{ link.title }}
      </a>
    </span>
  </ng-template>
</div>

<main class="content" role="main">
  <ciao-loading
    *ngIf="!routerOutlet.isActivated"
    data-cy="loading-spinner"
  ></ciao-loading>
  <router-outlet #routerOutlet="outlet"></router-outlet>
  <ciao-user-modal
    #userModal
    [id]="(this.currentUser$ | async)?.personId"
  ></ciao-user-modal>
  <ciao-team-roles-popup></ciao-team-roles-popup>
</main>

<div class="footer-container">
  <app-fs-footer></app-fs-footer>
</div>

<ciao-timeout-signout></ciao-timeout-signout>
